import { render, staticRenderFns } from "./cModalStoreDispatch.vue?vue&type=template&id=208d9b18&scoped=true&lang=es"
import script from "./cModalStoreDispatch.vue?vue&type=script&lang=js"
export * from "./cModalStoreDispatch.vue?vue&type=script&lang=js"
import style0 from "./cModalStoreDispatch.vue?vue&type=style&index=0&id=208d9b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d9b18",
  null
  
)

export default component.exports